import React from 'react'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import Markdown from 'react-markdown'

const FaqTopic = ({ data: { loading, error, faqTopic } }) => {
  if (error) return <h1>Error fetching the faqTopic!</h1>
  if (!loading) {
    return (
      <article>
        <h1>{faqTopic.topic}</h1>
        <div className='Post-placeholder'>
        </div>
        <Markdown
          source={faqTopic.topic}
          escapeHtml={false}
        />
      </article>
    )
  }
  return <h2>Loading faqTopic...</h2>
}

export const singleFaqTopic = gql`
  query singleFaqTopic($slug: String!) {
    faqTopic: FaqTopic(slug: $slug) {
      id
      slug
      topic
      createdAt
    }
  }
`

export default graphql(singleFaqTopic, {
  options: ({ match }) => ({
    variables: {
      slug: match.params.slug
    }
  })
})(FaqTopic)



// WEBPACK FOOTER //
// ./src/components/FaqTopic.js